import React from 'react';
import styled from 'styled-components';
import Modal from 'antd/lib/modal/Modal';
import PDFIcon from '../icons/PDFIcon';
import CheckedPDFIcon from '../icons/CheckedPDFIcon';
import DocumentLoader, { MIME } from '../../controllers/DocumentLoader';
import PDFLoader from '../../controllers/PDFtLoader';
import {useTranslation} from "@nic-react-i18n/core";


interface TestDescroptionModalInterface {
    showDocuments: boolean;
    onCancel: () => void;
    testType: string;
    testVersion: string;
}

type TestDescroptionModalProps = TestDescroptionModalInterface ;

const DocumentHeader = styled.div`
    display: flex;
    align-items: center;
    font-size: 1.8rem;
    margin-bottom: 30px;
    border-bottom: 1px solid #eeeeee;
    border-top: 1px solid #eeeeee;
`;

export const TestDescroptionModal: React.FC<TestDescroptionModalProps> = (props) => {
    const {t, locale} = useTranslation()
    const {showDocuments, testType, testVersion} = props;
    return (
        <Modal
            open={showDocuments}
            closable={true}
            style={{
                minWidth: '80vw',
            }}
            onCancel={() => {
                props.onCancel();
            }}
            footer={null}
            title={t('document.test.title')}
        >
            <DocumentHeader>
                    <span
                        style={{
                            fontSize: '1.0rem',
                            fontWeight: 800,
                            color: 'gray',
                            paddingRight: '20px'
                        }}
                    >
                        {t('document.test.attachment')}
                    </span>
                <PDFLoader
                    showText={true}
                    version={testVersion}
                    type={testType}
                    disabledIcon={<PDFIcon color={'gray'}/>}
                    enabledIcon={<CheckedPDFIcon/>}
                />
            </DocumentHeader>
            <DocumentLoader

                documentBase={`${testType}.test.${locale}`}
                baseURL={'templates'}
                mime={MIME.text}
            />

        </Modal>
    );
};